// Saas-core
export const SAAS_COOKIE_NAME = 'flexyBeauty-pro-user';

// Translations
export const DEFAULT_LANGUAGE = 'fr';

// Sentry
export const SENTRY_PUBLIC_TOKEN =
    'https://722c6f9e77364e8da9236cbfa4213794@o56217.ingest.sentry.io/5638868';

// Times in ms
export const ONE_SECOND = 1000;
export const ONE_MINUTE = ONE_SECOND * 60;
export const ONE_HOUR = ONE_MINUTE * 60;

export const AGENDA_REFRESH_RATE = ONE_MINUTE * 2;

export const AGENDA = {
    // Config and defaults
    HORIZONTAL_SCROLL_GROUP: 'AGENDA_HORIZONTAL_SCROLL_SYNC',
    GROUPING_NAME: 'belongsTo' as const,
    GROUPING: [{ resourceName: 'belongsTo' as const }],
    DEFAULT_RESOURCE: [
        {
            id: 0,
            name: 'tktpaspoto',
            color: 'white',
        },
    ],
    DISPLAYED_HOURS: {
        START: 7,
        END: 21,
    },
    MOBILE_CELL_DURATION: 15 as const,
    DESKTOP_CELL_DURATION: 30 as const,

    RESOURCE_LIMITS: {
        day: 21,
        discount: 21,
        threeDay: 7,
        week: 3,
        list: 99,
    } as const,
    MOBILE_MAX_RESOURCE_ON_SCREEN: 2,
    TIMESCALE_WIDTH_IN_PIXELS: 50,

    // Cell types
    INDISPO: 'Activity',
    BOOKING: 'BookingService',
    CLOSED: 'ClosedDay',
    DISCOUNT: 'Discount',
};

export const INTERCOM_APP_ID = 'xxmtyv4q';

export const REACT_NATIVE_RECEIVED_MESSAGE_TYPES = {
    GO_BACK: 'GO_BACK',
};

export const REACT_NATIVE_SENT_MESSAGE_TYPES = {};

export const RECOIL_KEYS = Object.freeze({
    SELECTED_DATE: 'SELECTED_DATE',
    RESOURCES: 'RESOURCES',
    RESOURCES_LOADING: 'RESOURCES_LOADING',
    RESOURCES_AS_ARRAY: 'RESOURCES_AS_ARRAY',
    RESOURCES_BY_ID: 'RESOURCES_BY_ID',
    RESOURCE_BY_AGENDA_ID: 'RESOURCE_BY_AGENDA_ID',
    SELECTED_RESOURCE_ID_FOR_BOOKING: 'SELECTED_RESOURCE_ID_FOR_BOOKING',
    RESOURCES_GROUPBY_SERVICE_ID: 'RESOURCES_BY_SERVICE_ID',
    HUMAN_RESOURCES: 'HUMAN_RESOURCES',
    PHYSICAL_RESOURCES: 'PHYSICAL_RESOURCES',
    SELECTED_RESOURCES_IDS: 'SELECTED_RESOURCES_IDS',
    SELECTED_RESOURCES: 'SELECTED_RESOURCES',
    SELECTED_RESOURCES_BY_AGENDA_VIEW: 'SELECTED_RESOURCES_BY_AGENDA_VIEW',
    CLONED_PHYSICAL_RESOURCES: 'CLONED_PHYSICAL_RESOURCES',
    CURRENT_CUSTOMER: 'CURRENT_CUSTOMER',
    CUSTOMERS: 'CUSTOMERS',
    CUSTOMERS_GENERATOR: 'CUSTOMERS_GENERATOR',
    CUSTOMERS_LOADING: 'CUSTOMERS_LOADING',

    LOGICAL_DAYS: 'LOGICAL_DAYS',
    LOGICAL_DAYS_LOADING: 'LOGICAL_DAYS_LOADING',
    BOOKINGS_SELECTOR: 'BOOKINGS_SELECTOR',
    BOOKINGS_ARRAY_SELECTOR: 'BOOKINGS_ARRAY_SELECTOR',
    BOOKING_FAMILY: 'BOOKING_FAMILY',
    BOOKING_FORM: 'BOOKING_FORM',
    FILTERED_BOOKINGS: 'FILTERED_BOOKINGS',
    DISCOUNTS_SELECTOR: 'DISCOUNTS_SELECTOR',
    DISCOUNTS_FAMILY: 'DISCOUNTS_FAMILY',
    DISCOUNT_ARRAY_SELECTOR: 'DISCOUNT_ARRAY_SELECTOR',
    PREVIEW_DISCOUNTS: 'PREVIEW_DISCOUNTS',
    FILTERED_DISCOUNTS: 'FILTERED_DISCOUNTS',
    CURRENT_BOOKING: 'CURRENT_BOOKING',
    CURRENT_BOOKING_LOADING: 'CURRENT_BOOKING_LOADING',
    IS_IN_OPENING_RANGE: 'IS_IN_OPENING_RANGE',
    IS_CELL_AVAILABLE: 'IS_CELL_AVAILABLE',
    RESOURCE_OPENING_RANGES: 'RESOURCE_OPENING_RANGES',

    CATALOG_LOADING: 'CATALOG_LOADING',
    CATALOG: 'CATALOG',

    TREATMENTS_LOADING: 'TREATMENTS_LOADING',
    ROOT_CATEGORY_LOADING: 'ROOT_CATEGORY_LOADING',
    TREATMENTS_ROOT_CATEGORY: 'TREATMENTS_ROOT_CATEGORY',
    TREATMENTS_BY_CATEGORY: 'TREATMENTS_BY_CATEGORY',
    CURRENT_TREATMENTS: 'CURRENT_TREATMENTS',

    AGENDA_CREATION_CONTEXT: 'AGENDA_CREATION_CONTEXT',
    REACT_NATIVE_NAVIGATION_CONTEXT: 'REACT_NATIVE_NAVIGATION_CONTEXT',
    LOCALE_ATOM_KEY: 'LOCALE_ATOM_KEY',
    LOCALE_SELECTOR_KEY: 'LOCALE_SELECTOR_KEY',

    COMMENT: 'COMMENT',
    AGENDA_SETTINGS: 'AGENDA_SETTINGS',
    AGENDA_LAYOUT: 'AGENDA_LAYOUT',
    AGENDA_LOADING: 'AGENDA_LOADING',
    AGENDA_SYNC: 'AGENDA_SYNC',

    TOOLTIP_CACHE: 'TOOLTIP_CACHE',
    LIST_VIEW_SELECTED_RESOURCES: 'LIST_VIEW_SELECTED_RESOURCES',
    APP_CONGIF: 'APP_CONFIG',
    UNREAD_NOTIFICATIONS_COUNT: 'UNREAD_NOTIFICATIONS_COUNT',

    MKP_RESOURCES: 'MKP_RESOURCES',

    VISITS: 'VISITS',
    VISITS_LOADING: 'VISITS_LOADING',

    TECH_NOTES: 'TECH_NOTES',
    TECH_NOTES_LOADING: 'TECH_NOTES_LOADING',
});

export const RECOIL_PERSIST_KEYS = Object.freeze({
    RESOURCES: 'resources-v2',
    SELECTED_RESOURCES_IDS: 'selectedresources',
    AGENDA_SETTINGS: 'agendasettings-v2',
    TOOLTIP_CACHE: 'tooltips',
    LIST_VIEW_SELECTED_RESOURCES: 'listviewselectedresources',
    UNREAD_NOTIFICATIONS_COUNT: 'unreadnotificationcount',
    MKP_RESOURCES: 'mkp-resources',
});

export const LOGICALDAY_KEYS = {
    HR: 'logicalDayHrGetResponses',
    PR: 'logicalDayPrGetResponses',
} as const;

export const RESOURCE_TYPES = {
    HUMAN: 'HumanResource',
    PHYSICAL: 'PhysicalResource',
} as const;

export type RESOURCE_TYPES_KEYS = keyof typeof RESOURCE_TYPES;
export type RESOURCE_TYPES_VALUES = typeof RESOURCE_TYPES[RESOURCE_TYPES_KEYS];

export const BOOKING_CREATORS = {
    WEBSITE: 'WEBSITE',
    BACKOFFICE: 'BACKOFFICE',
    RWG: 'RWG',
    LE_CISEAU: 'LE_CISEAU',
    TREATWELL: 'TREATWELL',
    APPMOBILE_PRO: 'APPMOBILE_PRO',
    APPMOBILE_CLI: 'APPMOBILE_CLI',
    BACKOFFICE_KIUTE_PRO: 'BACKOFFICE_KIUTE_PRO',
} as const;

export enum BOOKING_FORM_MODE {
    'CREATION' = 'creation',
    'EDIT' = 'edit',
}

export enum VISIT_ITEM_TYPE {
    'SERVICE' = 'service',
    'PRODUCT' = 'product',
    'LOYALTY_CARD_ITEM' = 'loyaltyCardItem',
    'CURE' = 'cure',
    'GIFT_ITEM' = 'giftItem',
}

export const KIUTE_LOGIN_URL = 'https://app.kiute.com/#/login';

export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const IS_MASTER =
    process.env.REACT_APP_SENTRY_RELEASE?.split('-')[0] === 'production';

export const CUSTOMERS = {
    REDIRECT_BOOKING_QUERY_NAME: 'to=bookingForm',
} as const;

export const RETRY_CHUNK_IMPORTS_NB = 3;
export const RETRY_CHUNK_IMPORTS_INTERVAL = 1000;

export const ROUTES = {
    // LOGIN RELATED
    LOGIN: '/login',
    LOGIN_FORGET_PASSWORD: '/forgetpassword',

    // SETTINGS RELATED
    SETTINGS: '/settings',

    // AGENDA RELATED
    AGENDA: '/agenda',
    AGENDA_CREATE_DISCOUNT: '/agenda/discount/creation',
    AGENDA_CREATE_ACTIVITY: '/agenda/activity/creation',
    AGENDA_CREATE_BOOKING: '/agenda/booking/creation',
    AGENDA_CREATE_BOOKING_CUSTOMER_SELECT: '/agenda/booking/creation/customers',
    AGENDA_CREATE_BOOKING_CUSTOMER_CREATE:
        '/agenda/booking/creation/customers/creation',
    AGENDA_CREATE_BOOKING_TREATMENTS: '/agenda/booking/creation/treatments',
    AGENDA_CREATE_BOOKING_TREATMENTS_EDIT:
        '/agenda/booking/creation/treatments/edit',
    AGENDA_EDIT_DISCOUNT: '/agenda/discount',
    AGENDA_EDIT_ACTIVITY: '/agenda/activity',
    AGENDA_EDIT_BOOKING: '/agenda/booking',
    AGENDA_NOTIFICATIONS: '/agenda/notifications',

    DESKTOP_AGENDA_CREATE_BOOKING: '/booking/creation',
    DESKTOP_AGENDA_CREATE_BOOKING_TREATMENTS: '/booking/creation/treatments',
    DESKTOP_AGENDA_CREATE_BOOKING_TREATMENTS_EDIT:
        '/booking/creation/treatments/edit',
    DESKTOP_AGENDA_CREATE_BOOKING_CUSTOMERS: '/booking/creation/customers',
    DESKTOP_AGENDA_CREATE_BOOKING_CUSTOMER_CREATE:
        '/booking/creation/customers/creation',
    DESKTOP_AGENDA_CREATE_DISCOUNT: '/discount/creation',
    DESKTOP_AGENDA_CREATE_ACTIVITY: '/activity/creation',
    DESKTOP_AGENDA_EDIT_DISCOUNT: '/discount',
    DESKTOP_AGENDA_EDIT_ACTIVITY: '/activity',
    DESKTOP_AGENDA_EDIT_BOOKING: '/booking',
    DESKTOP_AGENDA_NOTIFICATIONS: '/notifications',

    // CUSTOMERS RELATED
    CUSTOMERS_LIST: '/customers',
    CUSTOMERS_CREATE: '/customers/creation',
    CUSTOMERS_DETAILS: '/customers',
    CUSTOMERS_EDIT: '/customers/edit',

    // CATALOG
    CATALOG: '/catalog',
} as const;

export const SERVICE_WORKER_EVENT_TYPES = {
    NEW_NOTIFICATION: 'NEW_NOTIFICATION',
    UNREAD_COUNT: 'UNREAD_COUNT',
    INIT: 'INIT',
    TOKEN: 'TOKEN',
} as const;

export const WINDOW_MD_PX = 960 as const;
export const APP_CONFIG_CODE = {
    TECHNOTE: 'techNote',
} as const;

export const BOOKING_STATUS = {
    CAME: 'came',
    NOT_CAME: 'notCame',
    WAITING: 'waiting',
    WAIT_FOR_CONFIRM: 'waitingForConfirm',
    CREATED: 'created',
    PLANNED: 'planned',
    PAYED: 'payed',
} as const;

export const TAB_CUSTOMER = {
    VISIT: 'visit',
    TECH_NOTES: 'techNote',
    LOYALTY_CARD: 'loyaltyCard',
    CURE: 'cure',
    GIFT_ITEM: 'giftItem',
} as const;

export const tabSliderItems = [
    {
        label: 'Visites',
        value: 'visit',
    },
    {
        label: 'Fiches Techniques',
        value: 'techNote',
    },
];

export const QUERY_DESKTOP_SIZE = 960;
